import {
  Button,
  Collapse,
  Divider,
  Modal,
  notification,
  Pagination,
  Spin,
  Switch,
  Table,
  Tabs,
  Tag,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { Tooltip, message } from 'antd';

import Navbar from '../../components/Navbar';
import RestaurantSideNav from '../../components/dashboard/restaurant_side_nav';
import MobileDashTabs from '../../components/dashboard/MobileDashTabs';
import { InfoCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import Slider from 'react-slick';

import TablerCash from '../../assets/images/icons/tabler_cash.png';
import NumberFormat from 'react-number-format';
import {
  _fetch_user_wallet_data,
  _get_all_transaction_data,
  _get_bonus_history,
  _get_user_wallet_account,
  _get_user_wallet_history,
} from '../../common/axios_services';
import { useSelector } from 'react-redux';
import DeliveryPersonModal from '../../components/restaurant_delivery/DeliveryPersonModal';
import moment from 'moment';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';
import axiosCall from '../../common/axios_call';

let settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  initialSlide: 0,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        centerMode: true,
        focusOnSelect: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 1,
        centerMode: true,
        focusOnSelect: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        focusOnSelect: true,
      },
    },
  ],
};

const RestaurantDelivery = () => {
  const params = new URLSearchParams(window?.location?.search);
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [accountDetails, setAccountDetails] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState({ title: '', desc: '' });
  const [walletData, setWalletData] = useState({});
  const [showDeliveryInfo, setShowDeliveryInfo] = useState(false);
  const [currency] = useState('NGN');
  const [enabled, setEnabled] = useState(false);
  const [trans_his, setTrans_his] = useState([]);
  const [activeHistorySelection, setActiveHistorySelection] = useState({});
  const [activeHistoryDisplayModal, setActiveHistoryDisplayModal] =
    useState(false);
  const [bonusHistory, setBonusHistory] = useState([]);
  const [bonusFetched, setBonusFetched] = useState(false);
  const [loyalty_his, setLoyalty_his] = useState([]);
  const [page_size, setPage_size] = useState(10);
  const [page_no, setPage_no] = useState(1);
  const [pageLoy, setPageLoy] = useState(1);
  const [pageSizeLoy, setPageSizeLoy] = useState(10);
  const [bonusPage, setBonusPage] = useState(1);
  const [bonusPageSize, setBonusPageSize] = useState(10);
  const [errorMessage, setErrorMessage] = useState(false);
  const [updateCount, setUpdateCount] = useState(0);
  const [fetchingLoyalty, setFetchingLoyalty] = useState(true);
  const [page, setPage] = useState(1);
  const [per_page, setPer_page] = useState(10);
  const [total_trans, setTotal_trans] = useState(0);
  const [total_loyalty, setTotal_loyalty] = useState(0);
  const [total_bonus, setTotal_bonus] = useState(0);
  const [tx_ref] = useState(params.get('tx_ref') ? params.get('tx_ref') : '');
  const [status] = useState(params.get('status') ? params.get('status') : '');
  const [fundKonnect] = useState(
    params.get('fundKonnect') ? params.get('fundKonnect') : ''
  );
  const [fundWallet] = useState(
    params.get('fundWallet') ? params.get('fundWallet') : ''
  );
  const [minAmount] = useState(
    params.get('minAmount') ? params.get('minAmount') : ''
  );
  const [transaction_id] = useState(
    params.get('transaction_id') ? params.get('transaction_id') : ''
  );
  const [showTransaction, setShowTransaction] = useState(false);
  const [err_status, setErr_status] = useState(false);
  const [transMessage, setTransMessage] = useState(false);

  const navigate = useNavigate();

  const updateCounts = useSelector((state) => state?.updateCount?.count);

  const newAntIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: '#008060' }} spin />
  );

  const handleChange = (checked) => {
    setEnabled(checked);
  };

  const openModal = (title, desc, lists) => {
    setModalContent({ title, desc, lists });
    setModalVisible(true);
  };

  const openNotificationWithIcon = (type, title, message) => {
    notification[type]({
      message: title,
      description: message,
      placement: 'bottom-right',
    });
  };

  const fetchUserWalletBalance = async (e) => {
    try {
      let fetchUserAccountBalance = await _fetch_user_wallet_data();
      if (fetchUserAccountBalance.data.status === 'success') {
        setWalletData(fetchUserAccountBalance?.data?.data);
      } else {
        setWalletData({});
        openNotificationWithIcon(
          'error',
          'An error occurred while loading wallet balance. Please reload page to try again'
        );
      }
    } catch (err) {
      setWalletData({});
      openNotificationWithIcon(
        'error',
        'An error occurred while loading wallet balance. Please reload page to try again'
      );
    }
  };

  const getWalletAccount = async () => {
    try {
      let fetchAccounts = await _get_user_wallet_account();
      setAccountDetails(fetchAccounts?.data?.data);
    } catch (err) {
      setAccountDetails({});
      openNotificationWithIcon(
        'error',
        'An error occurred while loading wallet balance. Please reload page to try again'
      );
    }
  };

  const fetchUserWalletPayments = async () => {
    try {
      const getPayment = await _get_user_wallet_history({
        page: pageLoy,
        page_size: pageSizeLoy,
        account_type: 'wallet',
      });
      setLoyalty_his(getPayment.data.data);
      setFetchingLoyalty(false);
      setTotal_loyalty(getPayment?.data?.meta?.total);
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === 'Unauthorized') {
          localStorage.removeItem('konnect_token');
          navigate('/signin');
        }
        openNotificationWithIcon('error', err.response.data.message);
      } else {
        openNotificationWithIcon(
          'error',
          'An error occurred while loading loyalty data. Please reload page to try again'
        );
      }
    }
  };

  const fetchUserTransactionData = async () => {
    try {
      let userWalletTrx = await _get_all_transaction_data({ page, page_size });
      setTrans_his(userWalletTrx.data.data);
      setTotal_trans(userWalletTrx.data.meta.total);
      setFetchingLoyalty(false);
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === 'Unauthorized') {
          localStorage.removeItem('konnect_token');
          navigate('/signin');
        }
        openNotificationWithIcon('error', err.response.data.message);
      } else {
        openNotificationWithIcon('error', err.message);
      }
      setFetchingLoyalty(false);
    }
  };

  const getBounusHistory = async () => {
    setBonusFetched(false);
    try {
      const referrals = await _get_bonus_history({
        page: bonusPage,
        page_size: bonusPageSize,
      });
      if (referrals.data.status === 'success') {
        setBonusHistory(referrals?.data?.data);
        setTotal_bonus(referrals?.data?.meta?.total);
        setBonusFetched(true);
      } else {
        openNotificationWithIcon(
          'error',
          'An error occurred while loading referral history'
        );
        setBonusHistory([]);
        setBonusFetched(false);
      }
    } catch (err) {
      setBonusFetched(false);
      setBonusHistory([]);
      if (err.response) {
        if (err.response.data.message === 'Unauthorized') {
          localStorage.removeItem('konnect_token');
          navigate('/');
        }
        openNotificationWithIcon('error', err.response.data.message);
      } else {
        openNotificationWithIcon('error', err.message);
      }
      openNotificationWithIcon(
        'error',
        'An error occurred while loading referral history'
      );
    }
  };

  const change_page = (selected_page, pageSize) => {
    setPage(selected_page);
    setPer_page(pageSize);
  };

  const change_loyalty = (selected_page, pageSize) => {
    setPageLoy(selected_page);
    setPageSizeLoy(pageSize);
    setFetchingLoyalty(false);
  };

  const changeBonusPage = (selected_page, pageSize) => {
    setBonusPage(selected_page);
    setBonusPageSize(pageSize);
    setBonusHistory([]);
  };

  const trans_col = [
    {
      title: 'Date',
      dataIndex: 'date',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Reference',
      dataIndex: 'ref',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Service',
      className: 'column-number',
      dataIndex: 'service',
      align: 'center',
    },
    {
      title: 'Total',
      className: 'column-number',
      dataIndex: 'total_amount',
      align: 'center',
    },
    {
      title: 'Amount Paid',
      className: 'column-number',
      dataIndex: 'amount',
      align: 'center',
    },
    {
      title: 'Payment Method',
      className: 'column-number',
      dataIndex: 'paymentmethod',
      align: 'center',
    },
    {
      title: 'Payment Status',
      className: 'column-number',
      dataIndex: 'paymentstatus',
      align: 'center',
    },
    {
      title: 'Status',
      className: 'column-number',
      dataIndex: 'status',
      align: 'center',
    },
  ];

  const cashColumn = [
    {
      title: 'SN',
      dataIndex: 'sn',
    },
    {
      title: 'Transaction date',
      dataIndex: 'date',
    },
    {
      title: 'Service',
      dataIndex: 'service',
    },
    {
      title: 'Credit',
      className: 'column-number',
      dataIndex: 'credit',
    },
    {
      title: ' Debit',
      className: 'column-number',
      dataIndex: 'debit',
    },
  ];

  const walletHistoryColumn = [
    {
      title: '',
      dataIndex: 'sn',
    },
    {
      title: 'Date',
      dataIndex: 'date',
    },
    {
      title: 'Reference',
      dataIndex: 'reference',
    },
    {
      title: 'Service',
      dataIndex: 'service',
    },
    {
      title: 'Status',
      className: 'column-number',
      dataIndex: 'status',
      align: 'center',
    },
    {
      title: 'Credit',
      className: 'column-number',
      dataIndex: 'credit',
      align: 'right',
    },
    {
      title: 'Debit',
      className: 'column-number',
      dataIndex: 'debit',
      align: 'right',
    },
  ];

  let trans_history = trans_his?.map((trans, index) => {
    return {
      key: index,
      date: moment(trans?.timestamp).format('HH:mm YYYY-MM-DD'),
      ref: (
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setActiveHistorySelection(trans);
            setActiveHistoryDisplayModal(true);
          }}
        >
          {trans.transaction_ref}
        </span>
      ),
      service: trans.service,
      total_amount: (
        <NumberFormat
          thousandSeparator={true}
          displayType={'text'}
          value={Math.round(Number(trans.total_amount) * 1)}
        />
      ),
      amount: (
        <NumberFormat
          thousandSeparator={true}
          displayType={'text'}
          value={Math.round(Number(trans.total_amount_paid) * 1)}
        />
      ),
      paymentmethod: trans.payment_method,
      paymenttype: (
        <div style={{ textTransform: 'capitalize' }}>
          {trans.payment_type === 'credit' ? (
            <Tag color="green">{trans.payment_type}</Tag>
          ) : (
            <Tag color="red">{trans.payment_type}</Tag>
          )}
        </div>
      ),
      paymentstatus: (
        <div style={{ textTransform: 'capitalize' }}>
          {trans.payment_status === 'full-payment' ? (
            <Tag color="green">Paid</Tag>
          ) : trans.payment_status === 'no-payment' ? (
            <Tag color="red">Unpaid</Tag>
          ) : trans.payment_status === 'refund-payment' ? (
            <Tag color="orange">Refund</Tag>
          ) : (
            <Tag color="orange">{trans.payment_status}</Tag>
          )}
        </div>
      ),
      status: (
        <div style={{ textTransform: 'capitalize' }}>
          {trans.status === 'success' ? (
            <Tag color="#87d068">{trans.status}</Tag>
          ) : trans.status === 'cancel' || trans.status === 'canceled' ? (
            <Tag color="#cf1322">{trans.status}</Tag>
          ) : (
            <Tag color="#ffa500">{trans.status}</Tag>
          )}
        </div>
      ),
    };
  });

  let bonus_history = bonusHistory?.map((trans, index) => {
    return {
      key: index,
      sn: index + 1,
      date: trans?.timestamp?.split('T')[0],
      service: trans.service,
      credit:
        trans.payment_type === 'credit' ? (
          <div>
            {' '}
            <span className="currency">NGN</span>{' '}
            <NumberFormat
              thousandSeparator={true}
              displayType={'text'}
              value={Math.trunc(+trans.amount).toFixed(2)}
            />{' '}
          </div>
        ) : (
          '-'
        ),
      debit:
        trans.payment_type === 'debit' ? (
          <div>
            {' '}
            <span className="currency">NGN</span>{' '}
            <NumberFormat
              thousandSeparator={true}
              displayType={'text'}
              value={Math.trunc(+trans.amount).toFixed(2)}
            />{' '}
          </div>
        ) : (
          '-'
        ),
      balance: (
        <div>
          <span className="currency">NGN</span>
          <NumberFormat
            thousandSeparator={true}
            displayType={'text'}
            value={Math.trunc(+trans.new_voucher_bal).toFixed(2)}
          />
        </div>
      ),
    };
  });

  let wallet_history_data = loyalty_his?.map((trans, index) => {
    return {
      key: index,
      sn: index + 1,
      date: moment(trans?.timestamp).format('HH:mm YYYY-MM-DD'),
      reference: (
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setActiveHistorySelection(trans);
            setActiveHistoryDisplayModal(true);
          }}
        >
          {trans.referense_no}
        </span>
      ),
      service: trans.service,
      credit: (
        <div>
          {trans.payment_type === 'credit' ? (
            <>
              <span className="currency">NGN</span>
              <NumberFormat
                thousandSeparator={true}
                displayType={'text'}
                value={Math.trunc(+trans.total_amount).toFixed(2)}
              />{' '}
            </>
          ) : (
            '-'
          )}
        </div>
      ),
      debit: (
        <div>
          {trans.payment_type === 'debit' ? (
            <>
              <span className="currency">NGN</span>
              <NumberFormat
                thousandSeparator={true}
                displayType={'text'}
                value={Math.trunc(+trans.total_amount).toFixed(2)}
              />{' '}
            </>
          ) : (
            '-'
          )}
        </div>
      ),
      balance: (
        <div>
          {' '}
          <span className="currency">NGN</span>
          <NumberFormat
            thousandSeparator={true}
            displayType={'text'}
            value={Math.trunc(+trans.new_wallet_balance).toFixed(2)}
          />
        </div>
      ),
      status: (
        <div style={{ textTransform: 'capitalize' }}>
          {trans.payment_type === 'credit' ? (
            <Tag color="green">{trans.payment_type}</Tag>
          ) : (
            <Tag color="red">{trans.payment_type}</Tag>
          )}
        </div>
      ),
    };
  });

  useEffect(() => {
    fetchUserWalletBalance();
    getWalletAccount();
  }, [updateCounts]);

  useEffect(() => {
    getBounusHistory();
  }, [bonusPage, bonusPageSize]);

  useEffect(() => {
    if (tx_ref && status && transaction_id) {
      axiosCall(
        `/transactions/verify_payment_callback?status=${status}&tx_ref=${tx_ref}&transaction_id=${transaction_id}`
      )
        .then((res) => {
          setShowTransaction(true);
          setErr_status(false);
          setTransMessage(res.data.message);
          console.log({ msg: res.data.message });
        })
        .catch((err) => {
          setShowTransaction(true);
          if (err.response) {
            setErr_status(true);
            setTransMessage(err.response.data.message);
          } else {
            openNotificationWithIcon('error', 'network error');
          }
        });
    }
    fetchUserWalletPayments();
    fetchUserTransactionData();
  }, [
    per_page,
    page,
    tx_ref,
    status,
    transaction_id,
    page_size,
    page_no,
    updateCount,
    updateCounts,
    pageLoy,
    pageSizeLoy,
  ]);

  const tabItems = [
    {
      key: '1',
      label: 'Biker List',
      children: (
        <div>
          {fetchingLoyalty ? (
            <div>
              <Spin indicator={newAntIcon} />
            </div>
          ) : (
            <div>
              <div className="desktop show-all">
                <Table
                  scroll={{ x: true }}
                  pagination={false}
                  bordered
                  columns={walletHistoryColumn}
                  dataSource={wallet_history_data}
                />
                <div style={{ marginTop: '2%' }}></div>
                <Pagination
                  showSizeChanger
                  current={pageLoy}
                  total={total_loyalty}
                  showTotal={(total, range) =>
                    `${range[0]} - ${range[1]} of ${total} transaction`
                  }
                  defaultPageSize={per_page}
                  onChange={change_loyalty}
                />
              </div>
              <div className="mobile topup-data">
                <Collapse defaultActiveKey={[0]}>
                  {loyalty_his.map((trans, index) => (
                    <Collapse.Panel
                      showArrow={false}
                      key={index}
                      header={
                        <p style={{ display: 'inline' }}>
                          <span className="small_currency">NGN</span>
                          <NumberFormat
                            thousandSeparator={true}
                            prefix={''}
                            className="numeric"
                            displayType={'text'}
                            value={(+trans.total_amount).toFixed(2)}
                          />{' '}
                          {trans.payment_type} on{' '}
                          {DateTime.fromISO(
                            trans.timestamp.split('T')[0]
                          ).toLocaleString(DateTime.DATE_HUGE)}
                        </p>
                      }
                    >
                      <div>
                        <ul className="mobile-list-flex">
                          <li>
                            <span>Transaction Ref:</span>
                            <span>{trans.referense_no}</span>
                          </li>
                          <li>
                            <span>Service:</span>
                            <span>{trans.service}</span>
                          </li>
                          <li>
                            <span>Payment Mode:</span>
                            <span>{trans.mode}</span>
                          </li>
                          <li>
                            <span>Payment Type:</span>
                            <span>
                              {trans.payment_type === 'credit' ? (
                                <Tag color="green">{trans.payment_type}</Tag>
                              ) : (
                                <Tag color="red">{trans.payment_type}</Tag>
                              )}
                            </span>
                          </li>
                          <li>
                            <span>Status:</span>
                            <span>
                              <div style={{ textTransform: 'capitalize' }}>
                                {trans.status === 'success' ? (
                                  <Tag color="#87d068">{trans.status}</Tag>
                                ) : trans.status === 'cancel' ? (
                                  <Tag color="#cf1322">{trans.status}</Tag>
                                ) : (
                                  <Tag color="#ffa500">{trans.status}</Tag>
                                )}
                              </div>
                            </span>
                          </li>
                          <li>
                            <span>Action:</span>
                            <span>
                              <Button
                                onClick={() => {
                                  setActiveHistorySelection(trans);
                                  setActiveHistoryDisplayModal(true);
                                }}
                              >
                                View
                              </Button>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Collapse.Panel>
                  ))}
                </Collapse>
                <div style={{ marginTop: '2%' }}></div>
                <Pagination
                  showSizeChanger
                  current={pageLoy}
                  total={total_loyalty}
                  showTotal={(total, range) =>
                    `${range[0]} - ${range[1]} of ${total} transaction`
                  }
                  defaultPageSize={per_page}
                  onChange={change_loyalty}
                />
              </div>
            </div>
          )}
        </div>
      ),
    },
    {
      key: '2',
      label: "Today's Delivery",
      children: (
        <div>
          {bonusFetched ? (
            <>
              <div className="desktop show-all">
                <Table
                  columns={cashColumn}
                  pagination={false}
                  dataSource={bonus_history}
                  bordered
                />
              </div>
              <div className="mobile topup-data">
                <Collapse defaultActiveKey={[0]}>
                  {bonusHistory.map((trans, index) => (
                    <Collapse.Panel
                      showArrow={false}
                      key={index}
                      header={
                        <p style={{ display: 'inline' }}>
                          {trans.payment_type === 'credit' ? (
                            <span>
                              {' '}
                              <span className="currency">NGN</span>{' '}
                              <NumberFormat
                                thousandSeparator={true}
                                displayType={'text'}
                                value={Math.trunc(+trans.amount).toFixed(2)}
                              />{' '}
                            </span>
                          ) : (
                            <span>
                              {' '}
                              <span className="currency">NGN</span>{' '}
                              <NumberFormat
                                thousandSeparator={true}
                                displayType={'text'}
                                value={Math.trunc(+trans.amount).toFixed(2)}
                              />{' '}
                            </span>
                          )}
                          {trans.service} on{' '}
                          {DateTime.fromISO(
                            trans?.timestamp?.split('T')[0]
                          ).toLocaleString(DateTime.DATE_HUGE)}
                        </p>
                      }
                    >
                      <div>
                        <ul className="mobile-list-flex">
                          <li>
                            <span>Service:</span>
                            <span>{trans.service}</span>
                          </li>
                          <li>
                            <span>Date:</span>
                            <span>{trans?.timestamp?.split('T')[0]}</span>
                          </li>
                          <li>
                            <span>Credit:</span>
                            {trans.payment_type === 'credit' ? (
                              <span>
                                {' '}
                                <span className="currency">NGN</span>{' '}
                                <NumberFormat
                                  thousandSeparator={true}
                                  displayType={'text'}
                                  value={Math.trunc(+trans.amount).toFixed(2)}
                                />{' '}
                              </span>
                            ) : (
                              <span>&mdash;</span>
                            )}
                          </li>
                          <li>
                            <span>Debit:</span>
                            {trans.payment_type === 'debit' ? (
                              <span>
                                {' '}
                                <span className="currency">NGN</span>{' '}
                                <NumberFormat
                                  thousandSeparator={true}
                                  displayType={'text'}
                                  value={Math.trunc(+trans.amount).toFixed(2)}
                                />{' '}
                              </span>
                            ) : (
                              <span>&mdash;</span>
                            )}
                          </li>
                          <li>
                            <span>Balance:</span>
                            <span>
                              <span className="currency">NGN</span>
                              <NumberFormat
                                thousandSeparator={true}
                                displayType={'text'}
                                value={Math.trunc(
                                  +trans.new_voucher_bal
                                ).toFixed(2)}
                              />
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Collapse.Panel>
                  ))}
                </Collapse>
                <div style={{ marginTop: '2%' }}></div>
              </div>
              <Pagination
                showSizeChanger
                current={bonusPage}
                total={total_bonus}
                showTotal={(total, range) =>
                  `${range[0]} - ${range[1]} of ${total} transaction`
                }
                defaultPageSize={bonusPageSize}
                onChange={changeBonusPage}
              />
            </>
          ) : (
            <div className="">
              <Spin />
            </div>
          )}
        </div>
      ),
    },
    {
      key: '3',
      label: 'Previous Delivery',
      children: (
        <div>
          {!trans_his ? (
            <div>
              <Spin indicator={newAntIcon} />
            </div>
          ) : (
            <>
              <div className="desktop show-all">
                <Table
                  pagination={false}
                  bordered
                  columns={trans_col}
                  dataSource={trans_history}
                />
                <div style={{ marginTop: '2%' }}></div>
                <Pagination
                  showSizeChanger
                  current={page}
                  total={total_trans}
                  showTotal={(total, range) =>
                    `${range[0]} - ${range[1]} of ${total} transaction`
                  }
                  defaultPageSize={per_page}
                  onChange={change_page}
                />
              </div>
              <div className="mobile topup-data">
                <Collapse defaultActiveKey={[0]}>
                  {trans_his.map((trans, index) => (
                    <Collapse.Panel
                      showArrow={false}
                      key={index}
                      header={
                        <p style={{ display: 'inline' }}>
                          <span className="small_currency">NGN</span>
                          <NumberFormat
                            thousandSeparator={true}
                            prefix={''}
                            className="numeric"
                            displayType={'text'}
                            value={(+trans.amount).toFixed(2)}
                          />{' '}
                          {trans.payment_type} on{' '}
                          {DateTime.fromISO(
                            trans.created_at.split('T')[0]
                          ).toLocaleString(DateTime.DATE_HUGE)}
                        </p>
                      }
                    >
                      <div>
                        <ul className="mobile-list-flex">
                          <li>
                            <span>Transaction Ref:</span>
                            <span>{trans.transaction_ref}</span>
                          </li>
                          <li>
                            <span>Service:</span>
                            <span>{trans.service}</span>
                          </li>
                          <li>
                            <span>Amount:</span>
                            <span>
                              <span>
                                <span className="small_currency">NGN</span>
                                <NumberFormat
                                  thousandSeparator={true}
                                  displayType={'text'}
                                  value={Number(
                                    trans.total_amount_paid
                                  ).toFixed(2)}
                                />
                              </span>
                            </span>
                          </li>
                          <li>
                            <span>Payment Method:</span>
                            <span>{trans.payment_method}</span>
                          </li>
                          <li>
                            <span>Payment Status:</span>
                            <span>
                              <div style={{ textTransform: 'capitalize' }}>
                                {trans.payment_type === 'credit' ? (
                                  <Tag color="green">{trans.payment_type}</Tag>
                                ) : (
                                  <Tag color="red">{trans.payment_type}</Tag>
                                )}
                              </div>
                            </span>
                          </li>
                          <li>
                            <span>Status:</span>
                            <span>
                              <div style={{ textTransform: 'capitalize' }}>
                                {trans.status === 'success' ? (
                                  <Tag color="#87d068">{trans.status}</Tag>
                                ) : trans.status === 'cancel' ? (
                                  <Tag color="#cf1322">{trans.status}</Tag>
                                ) : (
                                  <Tag color="#ffa500">{trans.status}</Tag>
                                )}
                              </div>
                            </span>
                          </li>
                          <li>
                            <span>Date:</span>
                            <span>
                              {moment(trans?.timestamp).format(
                                'HH:mm YYYY-MM-DD'
                              )}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </Collapse.Panel>
                  ))}
                </Collapse>
                <div style={{ marginTop: '2%' }}></div>
                <Pagination
                  showSizeChanger
                  current={pageLoy}
                  total={total_loyalty}
                  showTotal={(total, range) =>
                    `${range[0]} - ${range[1]} of ${total} transaction`
                  }
                  defaultPageSize={per_page}
                  onChange={change_loyalty}
                />
              </div>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="userprofile">
      <Spin spinning={spinnerLoading} indicator={newAntIcon}>
        <div className="profile-content">
          <Navbar />
          <div className="gray_bg_profile">
            <div className="profile_to_left">
              <div className="">
                <div className="profile_nav">
                  <RestaurantSideNav />
                </div>
              </div>
            </div>
            <div className="profile_to_right">
              <div className="contain">
                <div className="main_container">
                  <MobileDashTabs />
                  <div className="main_container_title_div mb-5">
                    <div className="flex items-center flex-wrap p-6 gap-y-3 justify-between   ">
                      <h5 className="mt-0">My Delivery</h5>
                    </div>
                    <Divider style={{ margin: '0px 0 5px' }} />
                  </div>

                  <div className="main_container_inner_div">
                    <div className="profile_container">
                      <div className="slider_div_to_top">
                        <Slider {...settings}>
                          <div
                            key={1}
                            className="item grid-4-box colored color_5 loyalty_card"
                          >
                            <div className="slick-div">
                              <div className="slick-box">
                                <div className="icon-box">
                                  <img src={TablerCash} alt="tabler cash" />
                                </div>
                                <div className="slider-main-content">
                                  <p>Today&nbsp;s delivery</p>
                                  <h2>
                                    <NumberFormat
                                      thousandSeparator={true}
                                      displayType={'text'}
                                      value={
                                        accountDetails?.available_balance || 0
                                      }
                                    />
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            key={2}
                            className="item grid-4-box colored color_1 loyalty_card"
                            onClick={() =>
                              openModal('How bonuses work', '', [
                                {
                                  content:
                                    'You get cash bonuses when you refer friends and cashback from pay bill.',
                                },
                                {
                                  content:
                                    'We will credit your wallet every Sunday based on numbers of friends you refer and what you spend on food.',
                                },
                                // { content: '- Download our app' },
                                // { content: '- Refer other users' },
                                // { content: '- Recharge your bills' },
                                // { content: '<b>Use your cash bonus to:</b>' },
                                // { content: '- Discount shop payments' },
                                // { content: '- Get extra cash at Wise9ja' },
                                // { content: '- Get selected monthly for a NGN 50,000 cash gift' },
                              ])
                            }
                          >
                            <div className="slick-div">
                              <div className="slick-box">
                                <div className="icon-box">
                                  <img src={TablerCash} alt="tabler cash" />
                                </div>
                                <div className="slider-main-content">
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <p>Today&nbsp;s delivery</p>
                                    <Tooltip title="Click the box for more info">
                                      <InfoCircleOutlined
                                        style={{
                                          color: '#1E90FF',
                                          fontSize: '16px',
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                  <h2>
                                    <span
                                      style={{ marginRight: '3px' }}
                                      className="currency"
                                    >
                                      {currency}
                                    </span>
                                    <NumberFormat
                                      thousandSeparator={true}
                                      displayType={'text'}
                                      value={walletData?.bonus_bal || 0}
                                    />
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            key={3}
                            className="item grid-4-box colored color_1 loyalty_card"
                            onClick={() =>
                              openModal(
                                'Lien Balance',
                                'Cash kept in lieu till successful pick-up or delivery.'
                              )
                            }
                          >
                            <div className="slick-div">
                              <div className="slick-box">
                                <div className="icon-box">
                                  <img src={TablerCash} alt="tabler cash" />
                                </div>
                                <div className="slider-main-content">
                                  <div
                                    style={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <p>Previous delivery</p>
                                    <Tooltip title="Click the box for more info">
                                      <InfoCircleOutlined
                                        style={{
                                          color: '#1E90FF',
                                          fontSize: '16px',
                                        }}
                                      />
                                    </Tooltip>
                                  </div>
                                  <h2>
                                    <span
                                      style={{ marginRight: '3px' }}
                                      className="currency"
                                    >
                                      {currency}
                                    </span>
                                    <NumberFormat
                                      thousandSeparator={true}
                                      displayType={'text'}
                                      value={walletData?.lien_bal || 0}
                                    />
                                  </h2>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Slider>
                      </div>
                      <div className="space_between">
                        <DeliveryPersonModal />
                        <button
                          onClick={() => setShowDeliveryInfo(true)}
                          className="bg_side_green"
                        >
                          Delivery Info
                        </button>
                      </div>
                    </div>
                  </div>
                  <Tabs defaultActiveKey="1" items={tabItems} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Spin>

      <Modal
        open={showDeliveryInfo}
        onCancel={() => setShowDeliveryInfo(false)}
        centered={true}
        footer={null}
        title="Delivery Info"
      >
        <p className="flex justify-between">
          <span>Delivery switch</span>{' '}
          <Switch
            size="12"
            checked={enabled}
            onChange={handleChange}
            className={enabled ? 'bg-[#258635]' : 'bg-gray-400'}
          />{' '}
        </p>
        <ul>
          <li>Delivery fee is 15% (NGN 750 Min.)</li>
          <li>Mock-up field (Max 10%)</li>
        </ul>
      </Modal>
    </div>
  );
};

export default RestaurantDelivery;
